// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {2242: "6e7af81fe4e0cb97",5001: "8312348aca5c0805",7637: "e5802fe8507e4790",8737: "cdd296530d066847",}[chunkId] + ".css"
}